// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Results_modalOverlay__eWFfB","modalContent":"Results_modalContent__tEPbB"};